import { REJECT_MANY_WITHDRAWALS } from '../../routes';
import customAxios from "../../customAxios";


const withdrawalRejectMany = async (withdrawalId: Array<string>): Promise<any> => {
  try {
    return (await customAxios.put(REJECT_MANY_WITHDRAWALS, {withdrawalId})).data;
  } catch (error: unknown) {
    console.error({ ACCEPT_MANY_WITHDRAWALS: error });
    return false;
  }
};

export default withdrawalRejectMany;
